import { render, staticRenderFns } from "./Tag.vue?vue&type=template&id=3c23c008&scoped=true"
import script from "./Tag.vue?vue&type=script&lang=js"
export * from "./Tag.vue?vue&type=script&lang=js"
import style0 from "./Tag.vue?vue&type=style&index=0&id=3c23c008&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c23c008",
  null
  
)

export default component.exports